import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AlertesService } from '../../services/public/alertes.service';
import * as $ from 'jquery';
import { SignaturePadComponent } from '../../widgets/signature-pad/signature-pad.component';
@Component({
  selector: 'ngx-view-list-signataire',
  templateUrl: './view-list-signataire.component.html',
  styleUrls: ['./view-list-signataire.component.scss']
})
export class ViewListSignataireComponent implements OnInit {

  @Input() parentModal: BsModalRef;
  searchKeyWord: FormControl = new FormControl('');
  CAN_ADD_SIGNATAIRE: boolean = true;
  firstFormGroup: FormGroup;
  public signataires: any[] = [];
  my_tribunal: any = null
  signatureData: any;
  signature_user: string;

  @ViewChild(SignaturePadComponent) signaturePadComponent!: SignaturePadComponent;

  constructor(private _formBuilder: FormBuilder,
    private options: ModalOptions,
    private ngxService: NgxUiLoaderService,
    private modalService: BsModalService,

  ) {
    try {
      this.my_tribunal = JSON.parse(localStorage.getItem('my_tribunal'))
    } catch (e) {
      console.log('ERROR ON GET TRIBUNAL====> ')
      this.my_tribunal = null
    }
  }

  signature() {
    console.log('arise')
    const config: ModalOptions = {
      initialState: {

      }
    }

    const modal = this.modalService.show(SignaturePadComponent, Object.assign({}, config, { class: "modal-sm" }))
  }

  extraireDonnees(arr) {
    return arr.map(obj => ({
      firstName: obj.firstName,
      lastName: obj.lastName,
      numeroIdentification: obj.numeroIdentification || "",
      fonction: obj.fonction
    }));
  }

  async updateSignataires() {

    this.ngxService.start()
    const old_signataire = this.extraireDonnees(this.signataires);
    let new_signataire = [];
    $('#myTableSignataire tbody tr').each((index, row) => {
      const firstName = $(row).find('input[name="firstName"]').val();
      const lastName = $(row).find('input[name="lastName"]').val();
      const numeroIdentification = $(row).find('input[name="numeroIdentification"]').val();
      const fonction = $(row).find('input[name="fonction"]').val()
      new_signataire.push({
        firstName: firstName,
        lastName: lastName,
        numeroIdentification: numeroIdentification,
        fonction: fonction
      });
    });
  }

  ngOnInit(): void {

     this.signataires = [
      {
        firstName: 'Ababacar',
        lastName: 'Badji',
        numeroIdentification: 1,
        fonction: 'procureur'
      },
      {
        firstName: 'Hachimou',
        lastName: 'Diallo',
        numeroIdentification: 2,
        fonction: 'juge'
      },
      {
        firstName: 'Amina',
        lastName: 'Ka',
        numeroIdentification: 3,
        fonction: 'juge d\'instruction'
      }
    ];


    const self = this;
    $('#addSignataire').on('click', function () {
      const newRow = '<tr>' +
        '<td><input type="text" class="form-control rounded" name="firstName"  /></td>' +
        '<td><input type="text" class="form-control rounded" name="lastName"  /></td>' +
        '<td><input type="text" class="form-control rounded" name="numeroIdentification"  /></td>' +
        '<td><select class="form-control" name="fonction">' +
        '<option value="" selected></option> ' +
        '<option value="">Procureur</option> ' +
        '<option value="">Juge d\'instruction</option>' +
        '<option value="">Greffier</option>' +
        '</select></td>' +
        '<td>' +
        '<!-- <i class="fas fa-solid fa-pen text-primary signer mt-2 px-2" style="font-size:20px; cursor:pointer"></i>  -->' +
        '<i class="fas fa-solid fa-trash delete-row text-danger mt-2" style="font-size:20px; cursor:pointer"></i>' +
        '</td>' +
        '</tr>'
      $('#myTableSignataire tbody').append(newRow);
    });

    $('#myTableSignataire').on('click', '.delete-row', function () {
      $(this).closest('tr').remove();
    });

    $('#myTableSignataire').on('click', '.signer', function () {
      self.signature();
    })
  }

  updateSignataire(){

  }

  addSignataire(){

  }

  async onSubmit(form : NgForm){
    const signataires = [];
    console.log(form.value.firstName)
    // this.ngxService.start()

  }


}
